import {getCurrentInstance} from "vue";

export default function useTools() {
    const {proxy} = getCurrentInstance();

    const $i18n = proxy.$i18n;
    const $router = proxy.$router;
    const $route = proxy.$route;
    const $resource = proxy.$resource;
    const $refs = proxy.$refs;
    const $moment = proxy.$moment;
    const $swal = proxy.$swal;
    const $emit = proxy.$emit;


    return {
        $i18n,
        $router,
        $route,
        $resource,
        $refs,
        $moment,
        $swal,
        $emit,
    };
}
